/**
 Creates a select type input on an empty div.
 @param opts - {} - required.
 opts.list - [{}] - List of options for the select menu each property on the object will be attached to an html
    data attribute.
 opts.list[x].value -  - required value for $(this).val() functionality
 opts.template - hbs partial - template you want to use for the items in the select menu.
 opts.selected - optional - object that you want to be selected at start.

 #method .val() - returns the opts.list[x].value attribute for the selected item
 #method .set() - Select an element by data-val or data-value attribute
 ~event 'select' - emitted when any of the options in the list are clicked
 ******USED IN**********
 --Media Advanced Search
 */
import sdaSelectDefaultTemplate from '../templates/sdaSelectDefault.hbs';
import selectTemplate from '../templates/select.hbs';
import $ from 'jquery';
import './sdaSelectList';
import {each, find, keys} from 'lodash';

// TO DO: Create basic dropdown style without supplied template
// In the FUTURE: use 'change' event instead of 'select', because 'select' is standardized for text selection
// and thus is triggered on field focus (zero-length selection).
$.valHooks.sdaSelect = {
    get(el) {
        let result = $(el).data().val;

        if (result === undefined) {
            result = $(el).data().value;
        }

        return result;
    },
    set(el, val) {
        const that = $(el),
            $item = that.find('li[data-val=' + val + '],li[data-value=' + val + ']');

        if ($item.length) {
            that.data({val});
            $item.trigger('mouseup.select');
            that.trigger('select', val);
        } else {
            console.error('Value was not found in select');
            return null;
        }
        return that;
    },
};

$.fn.sdaSelect = function(opts = {}) {
    $(this).each(function() {
        const that = $(this),
            $template = opts && opts.template ? opts.template : sdaSelectDefaultTemplate,
            $listContent = that
                .find('.sda-select-list')
                .children()
                .clone();
        let inputTimeout;

        $(that).each(function() {
            this.type = 'sdaSelect';
        });

        that.html(selectTemplate());

        const $selectList = that.find('.sda-select-list'),
            $hiddenInput = that.find('.select-helper');

        // List of items was passed in dynamically
        if (opts.list instanceof Array && opts.list.length) {
            if (opts && opts.template) {
                multiList(opts);
            } else {
                simpleList(opts);
            }

            $selectList.sdaSelectList();
        }

        function simpleList(_opts) {
            const selected = find(_opts.list, function(item) {
                return item.selected === true;
            });

            $selectList.append($template(_opts.list));

            if (selected) {
                selected.value = selected.value || selected.val;
                that.find('.selected-item').html(selected.name);
                that.val(selected.value);
            }

            if (_opts.val) {
                that.val(_opts.val);
            }
        }

        function multiList(_opts) {
            // Insert each list item
            const selected = _opts.selected ? _opts.selected : _opts.list[0];

            that.find('.selected-item').html($template(selected));

            if (_opts.val) {
                that.val = _opts.val;
            }

            each(_opts.list, function(item) {
                const $el = $($template(item)),
                    $li = $('<li class="select-option"></li>');
                each(keys(item), function(key) {
                    $li.attr('data-' + key, item[key]);
                    //add specified classes to li items (used to show hide in advanced search)
                    $li.addClass(item.classes);
                });

                $el.wrap($li.clone());
                $selectList.append($el.parent());
            });

            that.val(selected.value || selected.val);
        }

        $listContent.length ? $selectList.html($listContent).sdaSelectList() : false;

        // Close this list if the click occurs outside of it
        that.on('focusout', function() {
            if (that.is(':hover')) {
                $hiddenInput.focus();
            } else {
                $hiddenInput.hide();
                $selectList.close();
            }
        });

        that.find('.chevron, .selected-item').on('mouseup', function() {
            if (!that.is('[disabled]')) {
                $selectList.toggleOpen();
            }
        });

        $selectList.on('change.val', function(e, val) {
            e.stopPropagation();

            that.removeClass('list-open');
            that.find('.selected-item').html(that.find('.selected[data-selectable]').html());

            that.data({
                val,
            });

            that.trigger('change.val', that.data().val);
            that.trigger('select', that.data().val);

            $selectList.close();
        });

        that.on('open', function() {
            $('.sda-select.list-open')
                .not(that)
                .close();

            if (!that.is('[disabled]')) {
                that.addClass('list-open');
                $selectList.find('.highlight').removeClass('highlight');
            }
        });

        that.on('mouseup', function() {
            that.find('.hidden-input-wrapper, .select-helper').show();
            $hiddenInput.focus();
        });

        that.on('close', function(e) {
            e.stopPropagation();
            that.removeClass('list-open');
        });

        that.attachMethod('getSelectedEl', function() {
            return that.find('.selected');
        });

        $hiddenInput.on('keyup', function(e) {
            const val = $hiddenInput
                    .val()
                    .trim()
                    .toLowerCase(),
                len = val.length,
                $highlight = $selectList.find('.highlight'),
                navigateUp = function() {
                    if ($highlight) {
                        if ($highlight.prev().length) {
                            $highlight.prev().addClass('highlight');
                            $highlight.removeClass('highlight');
                        } else {
                            $selectList
                                .find('[selectable]')
                                .last()
                                .addClass('highlight');
                            $highlight.removeClass('highlight');
                        }
                    } else {
                        $selectList
                            .find('[selectable]')
                            .last()
                            .addClass('highlight');
                    }
                },
                navigateDown = function() {
                    if ($highlight) {
                        if ($highlight.next().length) {
                            $highlight.next().addClass('highlight');
                            $highlight.removeClass('highlight');
                        } else {
                            $selectList
                                .find('[selectable]')
                                .first()
                                .addClass('highlight');
                            $highlight.removeClass('highlight');
                        }
                    } else {
                        $selectList
                            .find('[selectable]')
                            .first()
                            .addClass('highlight');
                    }
                },
                scrollToThis = function(el) {
                    const $ul = $selectList.find('ul'),
                        $el = $(el);

                    if ($el.position()) {
                        $ul.scrollTop($el.position().top + $ul.scrollTop());
                    }
                };

            if (inputTimeout) {
                clearTimeout(inputTimeout);
            }

            switch (e.which) {
                case 38: // up
                    e.preventDefault();
                    if (!$selectList.hasClass('list-open')) {
                        $selectList.open();
                    }
                    navigateUp();
                    break;
                case 40: // down
                    e.preventDefault();
                    if (!$selectList.hasClass('list-open')) {
                        $selectList.open();
                    }
                    navigateDown();
                    break;

                case 13: // enter
                    e.preventDefault();

                    if ($selectList.hasClass('list-open')) {
                        $highlight.removeClass('highlight').trigger('mouseup');
                    } else {
                        $selectList.open();
                    }

                    break;

                default:
                    if (!$selectList.hasClass('list-open')) {
                        $selectList.open();
                    }

                    inputTimeout = setTimeout(function() {
                        $hiddenInput.val('');
                    }, 1000);
                    $highlight.removeClass('highlight');

                    if (len) {
                        scrollToThis(
                            $selectList
                                .find('li')
                                .filter(function(i, el) {
                                    return (
                                        $(el)
                                            .text()
                                            .trim()
                                            .toLowerCase()
                                            .substring(0, len) === val
                                    );
                                })
                                .first()
                                .addClass('highlight'),
                        );
                    }

                    break;
            }
        });

        $hiddenInput.on('focus', function() {
            that.find('.hidden-input-wrapper').show();
        });

        if (that.attr('data-val')) {
            that.val(that.attr('data-val'));
        }

        return that;
    });

    return this;
};
